module.exports = __webpack_public_path__ + "static/works-fshqposters-786580a4b2b764384bc97cd4a592a524.jpg";